import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'

export const pathKey = 'customerAttributeSettings' satisfies PathKey
